/*@ngInject*/
const QuoteListRepository = function (baseRepository, currentSubmissionModel) {

    angular.extend(this, baseRepository);

    this.getQuoteList = function (submissionId, proposalId) {
        var url = '/rest/Quote/List',
            params = {
                submissionId: submissionId,
                proposalId: proposalId,
                registrationIdentifier: proposalId ? '/ProposalQuotes/' + proposalId : '/SubmissionQuotes/' + submissionId
            };

        currentSubmissionModel.addRegistration({url: url, params: params});

        return this.get(url, {params: params});
    };

    this.processGetResponseData = function (responseData) {
        return _.map(responseData, function (o) {
            o.summary = o.summary.replace(/\\n/g, '<br/>');
            return o;
        });
    };
};

angular.module('gw-um-submission')
    .service('quoteListRepository', QuoteListRepository);
